import axios from 'axios'
import * as types from '../constants/actionTypes'

// Thunk to fetch vehicle search options from static JSON endpoint
export function fetchVehicleOptions() {
  return (dispatch: any) => {
    dispatch({ type: types.RequestVehicleOptions })
    try {
      // The token is sent as an Authorization header by the axios interceptor
      // in config/axiosDefaults. It used to also be appended as an
      // `access_token` query param, which put a live credential into ALB
      // access logs, browser history and outbound Referer headers.
      const url = `${process.env.REACT_APP_BLINKER_API_URL}/api/v3/vehicle_search_options`
      return axios
        .get(url)
        .then((res) => {
          const opts = res.data || []
          dispatch({
            type: types.RequestVehicleOptionsSuccess,
            payload: opts,
          })
        })
        .catch((error) => {
          const errMsg =
            error.response?.data?.message || error.message || String(error)
          dispatch({
            type: types.RequestVehicleOptionsFailure,
            error: errMsg,
          })
        })
    } catch (err) {
      const errMsg = err instanceof Error ? err.message : String(err)
      dispatch({
        type: types.RequestVehicleOptionsFailure,
        error: errMsg,
      })
      return Promise.reject(err)
    }
  }
}
